import { createRoot } from 'react-dom/client'

import { App } from 'apps/omniauth'
import { getAppSettings } from 'common'
import { createBlockingHistory } from 'core/navigation'
import Settings from 'core/settings'
import createStore from 'create_store'
import initI18n from 'initializers/i18n'
import getBackendData from 'services/backend_data'

import 'reducers'

const BackendData = getBackendData()

document.addEventListener('DOMContentLoaded', async () => {
  const [{ value: [_, appSettings] }] = await Promise.allSettled([await getAppSettings(), await initI18n(BackendData.locale)])
  Settings.set(appSettings)

  const history = createBlockingHistory()
  const store = createStore(null, {}, history)

  createRoot(document.getElementById('root')).render(
    <App
      store={store}
      history={history}
    />
  )
})
